import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from 'src/models/useDashboardDaysModel';

import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import SecurityRiskDetectionCount from './SecurityRiskDetectionCount';
import SecurityRiskFileBlocking from './SecurityRiskFileBlocking';
import SecurityRiskMalwareDetection from './SecurityRiskMalwareDetection';
import SecurityRiskPhishingDetection from './SecurityRiskPhishingDetection';
import SecurityRiskSpamDetection from './SecurityRiskSpamDetection';
import SecurityRiskTimeOfClick from './SecurityRiskTimeOfClick';
import SecurityRiskTopRecipients from './SecurityRiskTopRecipients';
import SecurityRiskTopSender from './SecurityRiskTopSender';
import SecurityRiskTopUrl from './SecurityRiskTopUrl';
import SecurityRiskTopUsers from './SecurityRiskTopUsers';
import SecurityRiskWebReputation from './SecurityRiskWebReputation';
import { DashboardPeriod } from '@Types/dashboard';
import { useExpandSection } from '../useExpandSection';

export default function SecurityRisk() {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'securityRiskScan',
      period: daysModel.days.DashboardSecurityRisk as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.securityRisk')}
      titleBar={<TimeRangeSelector widgetId="DashboardSecurityRisk" />}
      barColor="#588FAA"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <SecurityRiskDetectionCount
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskFileBlocking
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskWebReputation
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskMalwareDetection
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskTopSender
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskSpamDetection
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskPhishingDetection
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskTopUsers
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskTopUrl
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskTimeOfClick
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
      <SecurityRiskTopRecipients
        data={data}
        day={daysModel.days['DashboardSecurityRisk']}
      />
    </DashboardLayout>
  );
}
